module.exports = __webpack_public_path__ + "static/media/hotel.88912eea.svg";